import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { functions } from "../../firebase/firebase";

const fetchEndpoint = functions.httpsCallable("fetchEndpoint");

export const fetchBuilding: any = createAsyncThunk(
	"buildings/fetchBuilding",
	async ({ api, id }: { api: string; id: string }) => {
		const response = await fetchEndpoint({ route: `/building/${id}`, api });
		const parsedResponse = JSON.parse(response.data);

		if (parsedResponse?.id) {
			return parsedResponse;
		} else {
			return { error: id };
		}
	}
);

export const buildingsSlice = createSlice({
	name: "buildings",
	initialState: {
		data: {},
		status: "",
		error: { message: "", id: "" },
	},
	reducers: {},
	extraReducers: {
		[fetchBuilding.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchBuilding.fulfilled]: (state: any, action: any) => {
			state.status = "succeeded";
			state.error = { message: "", id: "" };

			if (action.payload?.id) {
				state.data[action.payload.id] = action.payload;
			}
		},
		[fetchBuilding.rejected]: (state, action) => {
			state.status = "failed";
			state.error = { message: action.error.message, id: action.meta?.arg?.id };
		},
	},
});

export default buildingsSlice.reducer;
